import { reactive } from 'vue';

export const useAlertController = () => {
  const flow = {
    onDismiss: null,
    resolve: null
  }
  
  const state = reactive({
    isPresenting: false,
    data: null,
    delayPresentation: null
  });
  
  const isPresenting = () => {
    return state.isPresenting;
  } 
  
  const getData = () => {
    return state.data;
  }
  
  const getState = () => {
    return state;
  }  
  
  const present = ({onDismiss = null, data = null, autoDismiss = null, delayPresentation = null} = {}) => {
    state.data = data;
    state.isPresenting = true;
    state.delayPresentation = delayPresentation;
    
    if (autoDismiss) {
      setTimeout(() => {
        dismiss();
      }, autoDismiss);
    }
    
    if (!onDismiss) {
      flow.onDismiss = null;
      return new Promise((resolve, reject) => {
        flow.resolve = resolve;
      });
    } else {
      flow.onDismiss = onDismiss;
      flow.resolve = null;
    }
  }
  
  const dismiss = (result = null, data = null) => {
    state.isPresenting = false;
    
    if (flow.onDismiss) {
      flow.onDismiss({result, data});
    } else {
      flow.resolve({result, data});
    }
  }
  
  return {
    isPresenting,
    getData,
    present,
    dismiss,
    getState
  }
}
